import { render, staticRenderFns } from "./widget_details_popup.vue?vue&type=template&id=3012ac95&"
import script from "./widget_details_popup.vue?vue&type=script&lang=js&"
export * from "./widget_details_popup.vue?vue&type=script&lang=js&"
import style0 from "./widget_details_popup.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./widget_details_popup.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports